import React from 'react';
import LOOKUP from 'constants/lookup';
// Basic Components
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';

const SearchPOFilterBulkTrasfer = (props) => {
    return (
        <div className="searchBarContainer">
            <div className="row">
                {/*Search Inputs*/}
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-12 p-1">
                    <TextInput
                        name={`${props.pageName}PoFilter`}
                        type="number"
                        className="search-field"
                        floatingLabelText={LOOKUP.purchaseOrder.filters.po.label}
                        label={LOOKUP.purchaseOrder.filters.po.label}
                        hintText={LOOKUP.purchaseOrder.filters.po.hintText}
                        onPressKey={props.search}
                    />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-12  p-1 d-flex align-items-center">
                    <Button
                        type="IconSearchButton"
                        mini={true}
                        id="searchPOId"
                        label={LOOKUP.employee.filters.filterButton}
                        onTouchTap={props.search} />
                </div>
            </div>
        </div>
    );
};


export default SearchPOFilterBulkTrasfer;